import React, { useState } from 'react'
import Navigation from '../partials/Navigation'
import CameraIcon from '../images/camera.svg'
import ProfilePicUploadModal from '../components/ProfilePicUploadModal'
import { useSelector } from 'react-redux'
import { RootState } from '../store'
import UserProfileSettingRow from '../components/UserProfileSettingRow'
import { AuthenticatedUser } from '../types'
import ListGroup from '../components/ListGroup'
import Page from '../components/Page'

const ProfileSettings = () => {
  const user = useSelector((state: RootState) => state.app.user) as AuthenticatedUser
  const [visible, setVisible] = useState(false)

  return (
    <Page className="bg-white">
      <Navigation />

      <div className="container">
        <div className="row justify-content-center">
          <div className="col-12 col-lg-9 pt-4 pt-lg-5">
            <h1 className="text-center">Settings</h1>

            <div className="user-settings-wrap mt-6">
              <div className="user-settings-inner mx-auto">
                <ListGroup.Items>
                  <ListGroup.Item>
                    <div className="user-settings-row user-profile-pic-wrap position-relative pt-5">
                      <div className="user-profile-pic-inner position-absolute w-100">
                        <div
                          className="user-profile-pic-content rounded-circle d-flex justify-content-center align-items-center bg-primary text-white mx-auto position-relative"
                          onClick={() => setVisible(true)}
                        >
                          {user.profile_img_url && (
                            <img
                              src={user.profile_img_url}
                              className="user-profile-pic-img rounded-circle"
                              alt="user-profile-img"
                            />
                          )}
                          <div className="user-profile-pic-overlay position-absolute w-100 h-100 rounded-circle d-flex justify-content-center align-items-center">
                            <img src={CameraIcon} alt="profile-pic-icon"></img>
                          </div>
                        </div>
                      </div>
                    </div>

                    <UserProfileSettingRow
                      label={'First name'}
                      attribute="first_name"
                      initial={user.first_name || ''}
                    />
                  </ListGroup.Item>
                  <ListGroup.Item>
                    <UserProfileSettingRow label={'Last name'} attribute="last_name" initial={user.last_name || ''} />
                  </ListGroup.Item>

                  <ListGroup.Item>
                    <UserProfileSettingRow
                      label={'Phone number'}
                      attribute="phone_number"
                      initial={user.phone_number || ''}
                    />
                  </ListGroup.Item>

                  <ListGroup.Item>
                    <UserProfileSettingRow label={'Email'} attribute="user_email" initial={user.email || ''} />
                  </ListGroup.Item>

                  <ListGroup.Item>
                    <UserProfileSettingRow
                      label={'Password'}
                      attribute="user_pass"
                      initial=""
                      placeholder="***************"
                      clearOnSave={true}
                    />
                  </ListGroup.Item>
                </ListGroup.Items>
              </div>
            </div>

            <ProfilePicUploadModal
              show={visible}
              onHide={() => {
                setVisible(false)
              }}
            />
          </div>
        </div>
      </div>
    </Page>
  )
}

export default ProfileSettings
